<template>
	<div class="d-flex align-items-center justify-content-center" style="height: 100vh; position: absolute; top: 0">
		Hello, World!
	</div>
</template>
